// extracted by mini-css-extract-plugin
export default {"next":"CustomCarsoul_next__C3I-C","before":"CustomCarsoul_before__LANP9"};